module.exports = __webpack_public_path__ + "img/exh-image03.e8ccd3c6.jpg";